export const MenuData = [
    {
        item: "Moonwalker Breakfast Sandwich",
        description: "Brioche bun, fried egg, Catalpa Grove Farms sausage or bacon, cheddar, choice of aioli.",
        price: "$9.50"
    },
    {
        item: "Ham & Cheese Croissant",
        description: "Croissant, Catalpa Grove Farms ham, fried egg, choice of cheese.",
        price: "$9.50"
    },
    {
        item: "Avocado Toast",
        description: "Hewn bread, tomato, feta, pepitas, dukkah, arugula, lemon vinaigrette.",
        price: "$10.50"
    },
    {
        item: "Moonwalker Breakfast Burrito",
        description: "Flour tortilla, two eggs, cheddar, potatoes, choice of bacon or sausage.",
        price: "$9.50"
    },
    {
        item: "The Basic",
        description: "Everything bagel, choice of cream cheese, sliced tomatoes, arugula, lemon vinaigrette.",
        price: "$11.50"
    },
    {
        item: "The Brad",
        description: "Everything bagel, jalapeño cream cheese, roasted tomatoes, candied bacon.",
        price: "$11.50"
    },
    {
        item: "The Brunch",
        description: "Everything bagel, lox cream cheese, tomato, red onion, capers, arugula, lemon vinaigrette.",
        price: "$11.50"
    },
    {
        item: "B.L.T.",
        description: "You know what it is...",
        price: "$13.50"
    },
    {
        item: "Chicken Sandwich",
        description: "Fried or herb roasted chicken, lettuce, tomato, mushrooms, white cheddar, carmelized onions, arugula, choice of aioli.",
        price: "$13.50"
    },
    {
        item: "Ribeye Steak Sandwich",
        description: "Hewn baguette, mushrooms, white cheddar, carmelized onions, arugula. (Veggie version available)",
        price: "$13.50"
    },
    
]